(function () {
  'use strict';

  console.log('[Geared Finance] JS loaded');

  const REPAYMENT_API =
    'https://internal.gearedfinance.com.au/api/partnercalculator/GetCalculatorRepaymentValue';

  const POPUP_API =
    'https://internal.gearedfinance.com.au/api/partnercalculator/GetVendorPopup';

  const API_KEY =
    '40480977-65c1-497b-99cf-ac4f6cf3e6c9';

  const FINANCE_MINIMUM = 2200;

  let activeIframe = null;
  let originalBodyOverflow = '';
  let originalHtmlOverflow = '';

  /* =========================================================
     REPAYMENT
     ========================================================= */

  function loadGearedRepayments(root) {
    const container = root || document;

    const widgets = container.querySelectorAll(
      '[data-geared-collection-finance]'
    );

    console.log(
      '[Geared Finance] Widgets found:',
      widgets.length
    );

    widgets.forEach(function (widget) {

      if (widget.dataset.gearedInitialised === 'true') {
        return;
      }

      if (widget.dataset.gearedLoading === 'true') {
        return;
      }

      const amount = Number(widget.dataset.amount);

      if (
        !Number.isFinite(amount) ||
        amount < FINANCE_MINIMUM
      ) {
        return;
      }

      const repaymentElement =
        widget.querySelector('[data-geared-repayment]');

      if (!repaymentElement) {
        console.warn(
          '[Geared Finance] Repayment element not found',
          widget
        );
        return;
      }

      widget.dataset.gearedLoading = 'true';

      const repaymentUrl =
        REPAYMENT_API +
        '?CalculatorName=Hospm%20Rental' +
        '&Amount=' +
        encodeURIComponent(amount.toFixed(2)) +
        '&RepaymentTerm=5' +
        '&RepaymentType=1' +
        '&AmountType=inc%20GST' +
        '&PartnerAPIKey=' +
        encodeURIComponent(API_KEY);

      console.log(
        '[Geared Finance] Requesting repayment for:',
        amount
      );

      fetch(repaymentUrl)
        .then(function (response) {

          if (!response.ok) {
            throw new Error(
              'Repayment API returned HTTP ' +
              response.status
            );
          }

          return response.json();
        })

        .then(function (data) {

          console.log(
            '[Geared Finance] Response:',
            data
          );

          const repayment =
            Number(data.repaymentValue);

          if (Number.isFinite(repayment)) {

            repaymentElement.textContent =
              '$' + repayment.toFixed(2);

            widget.dataset.gearedInitialised =
              'true';

            console.log(
              '[Geared Finance] Displayed:',
              '$' + repayment.toFixed(2)
            );

          } else {

            repaymentElement.textContent =
              'finance options';

            widget.dataset.gearedInitialised =
              'true';
          }

          delete widget.dataset.gearedLoading;
        })

        .catch(function (error) {

          console.error(
            '[Geared Finance] Repayment error:',
            error
          );

          repaymentElement.textContent =
            'finance options';

          delete widget.dataset.gearedLoading;
        });
    });
  }


  /* =========================================================
     POPUP
     ========================================================= */

  function openGearedCollectionPopup(amount) {

    const modal =
      document.getElementById('geared-collection-modal');

    const popupContainer =
      document.getElementById(
        'geared-collection-popup-container'
      );

    if (!modal || !popupContainer) {
      console.error(
        '[Geared Finance] Popup elements not found'
      );
      return;
    }

    if (
      !Number.isFinite(amount) ||
      amount < FINANCE_MINIMUM
    ) {
      return;
    }

    originalBodyOverflow =
      document.body.style.overflow;

    originalHtmlOverflow =
      document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';

    document.documentElement.style.overflow =
      'hidden';

    modal.classList.add('active');

    popupContainer.innerHTML =
      '<div class="geared-collection-popup-loading">' +
      'Loading Geared Finance...' +
      '</div>';

    const popupUrl =
      POPUP_API +
      '?Amount=' +
      encodeURIComponent(amount.toFixed(2)) +
      '&RepaymentTerm=5' +
      '&IsAmountInclusiveGST=true' +
      '&PartnerAPIKey=' +
      encodeURIComponent(API_KEY);

    fetch(popupUrl)
      .then(function (response) {

        if (!response.ok) {
          throw new Error(
            'Popup API returned HTTP ' +
            response.status
          );
        }

        return response.text();
      })

      .then(function (html) {

        const iframe =
          document.createElement('iframe');

        iframe.id =
          'geared-collection-iframe';

        iframe.title =
          'Geared Finance';

        iframe.setAttribute(
          'scrolling',
          'no'
        );

        activeIframe = iframe;

        popupContainer.innerHTML = '';

        popupContainer.appendChild(iframe);

        const iframeDocument =
          iframe.contentDocument ||
          iframe.contentWindow.document;

        iframeDocument.open();

        iframeDocument.write(html);

        iframeDocument.close();
      })

      .catch(function (error) {

        console.error(
          '[Geared Finance] Popup error:',
          error
        );

        popupContainer.innerHTML =
          '<div class="geared-collection-popup-loading">' +
          'Unable to load Geared Finance. Please try again.' +
          '</div>';
      });
  }


  /* =========================================================
     CLOSE POPUP
     ========================================================= */

  function closeGearedCollectionPopup() {

    const modal =
      document.getElementById(
        'geared-collection-modal'
      );

    const popupContainer =
      document.getElementById(
        'geared-collection-popup-container'
      );

    if (modal) {
      modal.classList.remove('active');
    }

    document.body.style.overflow =
      originalBodyOverflow;

    document.documentElement.style.overflow =
      originalHtmlOverflow;

    if (popupContainer) {
      popupContainer.innerHTML = '';
    }

    activeIframe = null;
  }


  /* =========================================================
     POPUP TRIGGER
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const trigger =
        event.target.closest(
          '[data-geared-popup-trigger]'
        );

      if (!trigger) {
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      const amount =
        Number(trigger.dataset.amount);

      openGearedCollectionPopup(amount);
    }
  );


  /* =========================================================
     CLOSE BUTTON
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const closeButton =
        event.target.closest(
          '#geared-collection-modal-close'
        );

      if (!closeButton) {
        return;
      }

      event.preventDefault();

      event.stopPropagation();

      closeGearedCollectionPopup();
    }
  );


  /* =========================================================
     CLOSE WHEN CLICKING BACKDROP
     ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const modal =
        document.getElementById(
          'geared-collection-modal'
        );

      if (
        modal &&
        event.target === modal
      ) {
        closeGearedCollectionPopup();
      }
    }
  );


  /* =========================================================
     ESC KEY
     ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      const modal =
        document.getElementById(
          'geared-collection-modal'
        );

      if (
        event.key === 'Escape' &&
        modal &&
        modal.classList.contains('active')
      ) {
        closeGearedCollectionPopup();
      }
    }
  );


  /* =========================================================
     IFRAME HEIGHT
     ========================================================= */

  window.addEventListener(
    'message',
    function (event) {

      if (
        activeIframe &&
        event.source ===
          activeIframe.contentWindow &&
        event.data &&
        event.data.type === 'popupHeight' &&
        event.data.height
      ) {

        activeIframe.style.height =
          event.data.height + 'px';
      }
    }
  );


  /* =========================================================
     INITIAL LOAD
     ========================================================= */

  function initialiseGearedFinance() {

    console.log(
      '[Geared Finance] Initialising...'
    );

    loadGearedRepayments(document);

    observeCollectionProducts();
  }


  /* =========================================================
     DYNAMIC PRODUCT LOADING
     ========================================================= */

  function observeCollectionProducts() {

    const collectionGrids =
      document.querySelectorAll(
        '[data-collections-grid]'
      );

    console.log(
      '[Geared Finance] Collection grids:',
      collectionGrids.length
    );

    collectionGrids.forEach(
      function (collectionGrid) {

        const observer =
          new MutationObserver(
            function (mutations) {

              let hasNewNodes = false;

              mutations.forEach(
                function (mutation) {

                  mutation.addedNodes.forEach(
                    function (node) {

                      if (
                        node.nodeType === 1
                      ) {
                        hasNewNodes = true;
                        loadGearedRepayments(node);
                      }
                    }
                  );
                }
              );

              if (hasNewNodes) {
                console.log(
                  '[Geared Finance] New products detected'
                );
              }
            }
          );

        observer.observe(
          collectionGrid,
          {
            childList: true,
            subtree: true
          }
        );
      }
    );
  }


  /* =========================================================
     START
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseGearedFinance
    );

  } else {

    initialiseGearedFinance();

  }

})();